module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace1.03fd2b71.png";